<div class="amp-bar-wrapper" *ngIf="showBar">
    <span (click)="redirect()">Enviando {{sent}}/{{total}}</span>
    <amp-progress-bar (click)="redirect()" [value]="progress * 100" [stripes]="true" [showPercentage]="false" [onlyBar]="true" color="blue"></amp-progress-bar>
    <i class="bi-x-lg" (click)="dismiss()"></i>
</div>
